import $api from '../../utils/api.js'


const state = () => ({
    admins: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Admin'
    },
    formdata:{
        id:'',
        name:'',
        email:'',
        is_active:'true',
        password:'',
        confirmation:'',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.admins = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            email:payload.email,
            is_active:payload.is_active,
            password:'',
            confirmation:'',
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            email:'',
            is_active:'true',
            password:'',
            confirmation:'',
        },
        state.errors = []
    },
    CLEAR_ADMINS(state){
        state.admins = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getAdmins({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`admins?page=${state.admins.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createAdmins({ commit, state }) {
        return new Promise((resolve,reject) => {
            $api.post(`admins`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateAdmins({ state, commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`admins/${payload}`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    deleteAdmins({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`admins/${payload}`)
            .then(() => {
                dispatch('getAdmins').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    changeStatusAdmins({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`status/admins`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}